import React, { useContext, useEffect } from 'react';
import PrimaryNavigation from '../../components/header/PrimaryNavigation/index';
import ActionBar from './ActionBar/index';
import SideBar from './SideBar/index';
import ImagePreviews from './ImagePreviews/ImagePreviews';
import './styles.css';
import updateDocumentTitle from '../../utils/updateDocumentTitle';
import { useAppDispatch } from '../../store/configureStore';
import { setImageList, setIsLoading } from '../../store/slices/imagesSlice';

import initializePendoSession from '../../utils/analytics/pendoAnalytics';
import { SessionContext, UserContext } from '../../context';

// import { useSelector } from 'react-redux';
import { imageAPI } from '@fluke/baseline-client-apis';
import { getAllReports } from '../../store/slices/reportSlice';

export default function ImageManagement() {
  const dispatch = useAppDispatch();
  // const { session = {} } = useSelector((state) => state.images);
  const { userSettings } = useContext(UserContext);
  const { sessionStore, updateSessionStore } = useContext(SessionContext);

  const { currentOrganization, previewPageSize } = userSettings;

  const {
    activeQuery = '',
    previewPageIndex,
    sorted,
    activeHeader,
    selectedYear,
    selectedMonth,
    activeChild,
    searchId,
    sorted_by,
  } = sessionStore;

  useEffect(() => {
    dispatch(getAllReports());
  }, []);

  const fetchImagePreviews = async () => {
    let data = [];
    const searchParams = {
      search_string: activeQuery,
      sort_field: sorted_by,
      sort_direction: sorted,
      search_id: searchId,
      page_size: previewPageSize,
      page: previewPageIndex,
    };

    try {
      const { page_count, results } = await imageAPI.fetchBySearch(
        searchParams,
        currentOrganization,
      );
      data = await imageAPI.fetchPreviews(results, currentOrganization);

      // update provider page count
      updateSessionStore({ previewPageCount: page_count });
      // redux images
      dispatch(setImageList(data));
      dispatch(setIsLoading(false));
    } catch (error) {
      console.error('Error fetching image previews:', error);
      data = [];
    }
    dispatch(setImageList(data));
    dispatch(setIsLoading(false));
  };

  useEffect(() => {
    // pendo analytics are initialized here and
    // can be validated using pendo.validateInstall()
    // from the console
    initializePendoSession();
    updateDocumentTitle(window.location.pathname);
  }, []);

  useEffect(() => {
    //  fetch on settings update
    fetchImagePreviews();
    document?.querySelector('#imagePreviews')?.scrollTo(0, 0);
  }, [
    activeQuery,
    previewPageSize,
    previewPageIndex,
    sorted,
    searchId,
    activeHeader,
    selectedYear,
    selectedMonth,
    activeChild,
  ]);

  return (
    <div style={container}>
      <PrimaryNavigation />
      <ActionBar />
      <SideBar />
      <ImagePreviews />
    </div>
  );
}

const container = {
  display: 'grid',
  gridTemplateColumns: '245px 1fr',
  gridTemplateRows: 'repeat(2, 60px) 1fr',
  height: '100vh',
  overflow: 'hidden',
  background: '#222222',
};
